import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateMenuResult = { menu: '_menu' };
var _bulkCreateMenusRequest = { menus: '_menu' };
var _bulkCreateMenusResponse = { results: '_bulkCreateMenuResult' };
var _bulkMenuResult = { menu: '_menu' };
var _bulkUpdateMenuRequest = { menus: '_maskedMenu' };
var _bulkUpdateMenuResponse = { results: '_bulkMenuResult' };
var _cloneMenusRequest = {};
var _cloneMenusResponse = {};
var _createMenuRequest = { menu: '_menu' };
var _createMenuResponse = { menu: '_menu' };
var _deleteMenuRequest = {};
var _deleteMenuResponse = {};
var _duplicateMenuRequest = {};
var _duplicateMenuResponse = {};
var _getMenuRequest = {};
var _getMenuResponse = { menu: '_menu' };
var _getMenuSiteUrlRequest = {};
var _getMenuSiteUrlResponse = {};
var _listMenusRequest = {};
var _listMenusResponse = { menus: '_menu' };
var _maskedMenu = { mask: 'google.protobuf.FieldMask', menu: '_menu' };
var _menu = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryMenusRequest = {};
var _queryMenusResponse = { menus: '_menu' };
var _queryMenusSiteUrlRequest = {};
var _queryMenusSiteUrlResponse = {};
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = {};
var _updateMenuRequest = { mask: 'google.protobuf.FieldMask', menu: '_menu' };
var _updateMenuResponse = { menu: '_menu' };
function resolveComWixpressRestaurantsMenusMenuV1RestaurantsDuplicateMenuRestaurantsDuplicateMenuUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-menu',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/menus-menu',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/menus',
                destPath: '/v1/bulk/menus',
            },
            {
                srcPath: '/restaurants/menus/v1/menus',
                destPath: '/v1/menus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-menu',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Menus API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates a menu.
 *
 * To create multiple menus at once, use [Bulk Create Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-create-menus).
 */
export function createMenu(payload) {
    var _a = serializer(_createMenuRequest, {
        _menu: _menu,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMenuResponse, { _menu: _menu }).fromJSON;
    function __createMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.CreateMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMenu.fromReq = fromReq;
    __createMenu.__isAmbassador = true;
    return __createMenu;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple menus at once.
 */
export function bulkCreateMenus(payload) {
    var _a = serializer(_bulkCreateMenusRequest, { _menu: _menu }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateMenusResponse, {
        _bulkCreateMenuResult: _bulkCreateMenuResult,
        _menu: _menu,
    }).fromJSON;
    function __bulkCreateMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.BulkCreateMenus',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/bulk/menus/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateMenus.fromReq = fromReq;
    __bulkCreateMenus.__isAmbassador = true;
    return __bulkCreateMenus;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a menu by ID.
 */
export function getMenu(payload) {
    var _a = serializer(_getMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMenuResponse, { _menu: _menu }).fromJSON;
    function __getMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.GetMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/{menuId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMenu.fromReq = fromReq;
    __getMenu.__isAmbassador = true;
    return __getMenu;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 menus.
 */
export function listMenus(payload) {
    var _a = serializer(_listMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMenusResponse, { _menu: _menu }).fromJSON;
    function __listMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.ListMenus',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMenus.fromReq = fromReq;
    __listMenus.__isAmbassador = true;
    return __listMenus;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of menus given the provided paging, filtering, and sorting. Up to 500 menus can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryMenus(payload) {
    var _a = serializer(_queryMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMenusResponse, { _menu: _menu }).fromJSON;
    function __queryMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.QueryMenus',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMenus.fromReq = fromReq;
    __queryMenus.__isAmbassador = true;
    return __queryMenus;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates a menu.
 *
 * To update multiple menus at once, use [Bulk Update Menu](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-update-menu).
 *
 * Each time a menu is updated, its revision increments by 1. The existing revision must be included when updating a menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
 */
export function updateMenu(payload) {
    var _a = serializer(_updateMenuRequest, {
        _menu: _menu,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMenuResponse, { _menu: _menu }).fromJSON;
    function __updateMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.UpdateMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/{menu.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMenu.fromReq = fromReq;
    __updateMenu.__isAmbassador = true;
    return __updateMenu;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple menus at once.
 *
 * Each time a menu is updated, its revision increments by 1. The existing revision must be included when updating the menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
 */
export function bulkUpdateMenu(payload) {
    var _a = serializer(_bulkUpdateMenuRequest, { _maskedMenu: _maskedMenu, _menu: _menu }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateMenuResponse, {
        _bulkMenuResult: _bulkMenuResult,
        _menu: _menu,
    }).fromJSON;
    function __bulkUpdateMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.BulkUpdateMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/bulk/menus/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateMenu.fromReq = fromReq;
    __bulkUpdateMenu.__isAmbassador = true;
    return __bulkUpdateMenu;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates only the `extendedFields` field.
 */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {}).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.UpdateExtendedFields',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/{id}/updateExtendedFields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes a menu.
 */
export function deleteMenu(payload) {
    var _a = serializer(_deleteMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMenuResponse, {}).fromJSON;
    function __deleteMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'DELETE',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.DeleteMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/{menuId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMenu.fromReq = fromReq;
    __deleteMenu.__isAmbassador = true;
    return __deleteMenu;
}
/** Clone menus from a different metasite */
export function cloneMenus(payload) {
    var _a = serializer(_cloneMenusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneMenusResponse, {}).fromJSON;
    function __cloneMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.CloneMenus',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
                protoPath: '/v1/menus/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneMenus.fromReq = fromReq;
    __cloneMenus.__isAmbassador = true;
    return __cloneMenus;
}
/** Get menu details and path URL by menu ID. */
export function getMenuSiteUrl(payload) {
    var _a = serializer(_getMenuSiteUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMenuSiteUrlResponse, {}).fromJSON;
    function __getMenuSiteUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.restaurants_menus_site_url.RestaurantsMenusSiteUrl.GetMenuSiteUrl',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl({
                protoPath: '/v1/menus-site-url/menus/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMenuSiteUrl.fromReq = fromReq;
    __getMenuSiteUrl.__isAmbassador = true;
    return __getMenuSiteUrl;
}
/** Query menu details and path URL */
export function queryMenusSiteUrl(payload) {
    var _a = serializer(_queryMenusSiteUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMenusSiteUrlResponse, {}).fromJSON;
    function __queryMenusSiteUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.restaurants_menus_site_url.RestaurantsMenusSiteUrl.QueryMenusSiteUrl',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl({
                protoPath: '/v1/menus-site-url/menus/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMenusSiteUrl.fromReq = fromReq;
    __queryMenusSiteUrl.__isAmbassador = true;
    return __queryMenusSiteUrl;
}
export function duplicateMenu(payload) {
    var _a = serializer(_duplicateMenuRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_duplicateMenuResponse, {}).fromJSON;
    function __duplicateMenu(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.menu',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.menus_menu.v1.restaurants_duplicate_menu.RestaurantsDuplicateMenu.DuplicateMenu',
            url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsDuplicateMenuRestaurantsDuplicateMenuUrl({ protoPath: '/v1/menus/{id}/duplicate', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __duplicateMenu.fromReq = fromReq;
    __duplicateMenu.__isAmbassador = true;
    return __duplicateMenu;
}
//# sourceMappingURL=http.impl.js.map